import { render, staticRenderFns } from "./HospitalShenHe.vue?vue&type=template&id=18522952&scoped=true"
import script from "./HospitalShenHe.vue?vue&type=script&lang=js"
export * from "./HospitalShenHe.vue?vue&type=script&lang=js"
import style0 from "./HospitalShenHe.vue?vue&type=style&index=0&id=18522952&prod&lang=scss&scoped=true"
import style1 from "./HospitalShenHe.vue?vue&type=style&index=1&id=18522952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18522952",
  null
  
)

export default component.exports